import { PlaceActionType } from './place-action-type';

export interface UpdatePlaceSuccessAction {
  placeKey: string;
  type: PlaceActionType.UpdatePlaceSuccess;
}

export const updatePlaceSuccess = (
  placeKey: string,
): UpdatePlaceSuccessAction => ({
  placeKey,
  type: PlaceActionType.UpdatePlaceSuccess,
});
